import { Stack, Text } from "@mantine/core";

import { SeoOpeningTagline } from "./SeoCommon";
import { SeoFooter } from "./SeoFooter";
import { SeoSection } from "./SeoSection";

export const InibuildsA350Seo = (): JSX.Element => {
  return (
    <Stack>
      <SeoSection title="Master the newest wide-body">
        <Text fz="medium">
          The iniBuilds A350 brings Airbus's most advanced wide-body to MSFS with stunning detail.
          Whether you're flying ultra-long-haul routes or exploring new destinations, a good
          checklist keeps you on track.{" "}
          <SeoOpeningTagline />
        </Text>
      </SeoSection>
      <SeoSection title="Tame the technology">
        <Text fz="medium">
          Brake to Vacate, OIS airport maps, advanced autoflight — the A350 is packed with systems
          that reward pilots who know their flows. This checklist, based on{" "}
          <a
            href="https://www.youtube.com/@jaydeegaming"
            target="_blank"
            data-goatcounter-click="jaydee-youtube-link"
          >
            JayDee
          </a>
          's A350 on{" "}
          <a
            href="https://msfschecklist.de"
            target="_blank"
            data-goatcounter-click="msfschecklist-link"
          >
            msfschecklist.de
          </a>
          , helps you stay ahead of the jet from cold and dark to shutdown. With{" "}
          <Text span c="black" fw="bold">
            fs-checklist-studio
          </Text>{" "}
          you can customize it to your liking, export as a PDF, and share it with your crew.
        </Text>
        <SeoFooter />
      </SeoSection>
    </Stack>
  );
};
